import $ from 'jquery';
import Slick from 'slick-carousel';


$(document).ready(function () {


    //home page slider
    $('.homepage-slider').slick({
        //      lazyLoad: 'ondemand',
        //      pauseOnFocus: true,
        //      pauseOnHover: true,
        infinite: false,
        autoplay: true,
        autoplaySpeed: 5000,
        dots: false,
        dotsClass: 'slick-dots',
        draggable: true,
        useTransform: true,
        cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
        easing: 'easeInOutCubic',
        speed: 1000,
        prevArrow: "<div class=\"slider-arrow-wrapper left\"><svg class=\"icon-angle slick-prev home-slider-arrows\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#angle\"></use></svg></div>",
        nextArrow: "<div class=\"slider-arrow-wrapper right\"><svg class=\"icon-angle slick-next home-slider-arrows\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#angle\"></use></svg></div>"
    });


    //home page tour slider
    var tourSlider = $('#tours-slider');
    if (tourSlider.length) {
        var tourSliderMaskContainer = document.createElement('div');
        tourSliderMaskContainer.classList.add('tours-svg-wrapper');

        for (var i = 0; i < 3; i++) {
            var tourSliderMask = document.createElement('div');
            tourSliderMask.classList.add('tours-svg');
            var svgMask = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            $(svgMask).attr('viewBox','0 0 300 300');
            $(svgMask).attr('class','circle-mask');
            $(svgMask).html('<defs><mask id="mask2"><rect width="100%" height="100%" fill="white"></rect><circle cx="50%" cy="50%" r="40%" fill="black"></circle></mask></defs><rect x="0" y="0" width="100%" height="100%" fill="#E9E6E6" mask="url(#mask2)"></rect>');


            $(svgMask).appendTo(tourSliderMask);
            $(tourSliderMask).appendTo(tourSliderMaskContainer);
        }

        $('.homepage-tours-slider-images').on('init', function (event, slick) {
            var svgWrapper = slick['$list'].append(tourSliderMaskContainer);
        });
        $('.homepage-tours-slider-images').on('breakpoint', function (event, slick) {
            var svgWrapper = slick['$list'].append(tourSliderMaskContainer);
        });
        $('.homepage-tours-slider-images').slick({
            draggable: false,
            swipe: false,
            accessibility: false,
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 3,
            adaptiveHeight: true,
            prevArrow: "<div class=\"tours-slider-arrow-wrapper left\"><svg class=\"icon-angle slick-prev\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#angle\"></use></svg></div>",
            nextArrow: "<div class=\"tours-slider-arrow-wrapper right\"><svg class=\"icon-angle slick-next\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#angle\"></use></svg></div>",
            asNavFor: '.homepage-tours-slider-text',
            responsive: [
                {
                  breakpoint: 1201,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                  }
                },
                {
                  breakpoint: 901,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                  }
                },
                {
                  breakpoint: 601,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }]
        });

//        console.log($('.homepage-tours-slider-images').slick('getSlick').$list);

        $('.homepage-tours-slider-text').slick({
            draggable: false,
            swipe: false,
            accessibility: false,
            dots: false,
            infinite: true,
            arrows: false,
            speed: 300,
            slidesToShow: 3,
            adaptiveHeight: true,
            responsive: [
                {
                  breakpoint: 1201,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                  }
                },
                {
                  breakpoint: 901,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                  }
                },
                {
                  breakpoint: 601,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }]
//            asNavFor: '.homepage-tours-slider-images'
        });
    }


    //single page gallery

    $('.content-slider-large').slick({
        accessibility: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.content-slider-thumbs   '
    });

    $('.content-slider-thumbs').slick({
        centerMode: true,
        accessibility: false,
        slidesToShow: 7,
        slidesToScroll: 1,
        asNavFor: '.content-slider-large',
        dots: false,
        focusOnSelect: true,
        prevArrow: "<div class=\"slider-arrow-wrapper left\"><svg class=\"icon-angle slick-prev\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#angle\"></use></svg></div>",
        nextArrow: "<div class=\"slider-arrow-wrapper right\"><svg class=\"icon-angle slick-next\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#angle\"></use></svg></div>",
        responsive: [
            {
                breakpoint: 1600,
                settings: {
                    slidesToShow: 5,
                }
            },
            {
                breakpoint: 920,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    arrows: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                     arrows: false
                }
            },
        ]
    });


    $('.room-images').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        prevArrow: "<div class=\"room-slider-arrow-wrapper left\"><svg class=\"icon-angle slick-prev\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#angle\"></use></svg></div>",
        nextArrow: "<div class=\"room-slider-arrow-wrapper right\"><svg class=\"icon-angle slick-next\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#angle\"></use></svg></div>"
    });

});


// WEBPACK FOOTER //
// ./assets/js/src/modules/slider.js